<template>
  <div class="tw-flex-grow">
    <AuthorPage
      v-if="isAuthorRoute"
    />
    <template v-else-if="menu">
      <ThemedComponent
        v-if="category === PREFIX_ROUTE.en.category"
        path="Page"
        :component-name="`${menu.componentName}`"
      />
      <ThemedComponent
        v-else
        path="Page"
        :component-name="`Detail${menu.componentName}`"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import PREFIX_ROUTE from '~/constants/route/prefix'
import { LANGUAGES } from '~/constants/language'
import { fullyDecodeRouteParam } from '~/utils/route'
import AuthorPage from '~/components/AuthorPage.vue'

definePageMeta({
  alias: LANGUAGES.map(lang => `/${lang}/:slug/:category/:categorySlug`),
})

const route = useRoute()
const category = computed(() => String(route.params.category || ''))
const isAuthorRoute = computed(() => category.value === 'authors')
const menuStore = useMenuStore()

if (menuStore.allList.length === 0) {
  await menuStore.fetch().catch(() => undefined)
}

const normalizedSlug = computed(() => fullyDecodeRouteParam(String(route.params.slug || '')))
const menu = computed(() =>
  menuStore.allList.find((item: Menu) => fullyDecodeRouteParam(item.slug) === normalizedSlug.value),
)

const { getPath } = useNavigationMenu()

const handleRouting = async () => {
  if (isAuthorRoute.value) {
    if (menu.value && menu.value.componentName !== 'Article') {
      throw createError({
        statusCode: 404,
        statusMessage: 'Page not found',
      })
    }
    return
  }

  if (PREFIX_ROUTE.th.category === route.params.category) {
    await navigateTo(
      getPath({
        componentName: menu.value?.componentName || '',
        categorySlug: route.params.categorySlug as string,
      }),
    )
    return
  }

  if (!menu.value) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page not found',
    })
  }
}

await handleRouting()
</script>
